var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowOneLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 8,
    fill: "#5F11EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.517 113.759L105.525 113.766C109.492 117.733 115.925 117.733 119.893 113.766L134.622 99.0367C138.59 95.069 138.59 88.636 134.622 84.6683L134.615 84.6612C130.647 80.6935 124.214 80.6935 120.246 84.6612L105.517 99.3903C101.55 103.358 101.55 109.791 105.517 113.759Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5725 125.134L81.5796 125.141C85.5473 129.109 91.9803 129.109 95.948 125.141L110.677 110.412C114.645 106.444 114.645 100.012 110.677 96.0438L110.67 96.0367C106.702 92.069 100.269 92.069 96.3016 96.0367L81.5725 110.766C77.6048 114.733 77.6048 121.166 81.5725 125.134Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4 125.5L128.94 112.88C127.87 111.79 126.01 112.55 126.01 114.08V120.37C126.01 120.37 116.95 122.81 106.24 113.69C106.24 113.69 105.49 130.63 126.01 130.63V136.6C126.01 138.12 127.84 138.88 128.92 137.82L141.4 125.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowOneLink);
export default __webpack_public_path__ + "static/media/icon-flow-one-link.4aa5fd234574083676313769ff03ce48.svg";
export { ForwardRef as ReactComponent };